import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  constructor(private snackBar: MatSnackBar,
    private toastr: ToastrService,
  ) { }

  showNotification(message: string, action: string, messageType: string) {
    // let panelClass: string[] = [];
    console.log(message,messageType);
    
    if (messageType === 'success') {
      this.toastr.success(message)
      // panelClass = ['success-message'];
    } else if (messageType === 'warning') {
      // panelClass = ['warning-message'];
      this.toastr.error(message)
    } else if (messageType === 'error') {
      this.toastr.error(message)
      // panelClass = ['error-message'];
    }
    // this.toastr.error(message)
    // this.snackBar.open(message, action, {
    //   duration: 3000, // Adjust the duration as needed
    //   panelClass: panelClass, // Apply your custom CSS class for styling
    // });
  }
}
